import styles from './RouteSkeleton.module.scss';

export default function RouteSkeleton() {
  return (
    <div className={styles.skeleton} role="status" aria-live="polite">
      <div className={styles.bar} />
    </div>
  );
}
